import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { fetchWithAuth } from "../api/fetchWithAuth";

function VersionFormModal({ show, onClose, onSaved, version }) {
  const [form, setForm] = useState({
    name: "",
    description: "",
    isActive: false,
    closed: false
  });

  useEffect(() => {
    setForm({
      name: version?.name ?? "",
      description: version?.description ?? "",
      isActive: Boolean(version?.isActive),
      closed: Boolean(version?.closed)
    });
  }, [version, show]);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    setForm((current) => {
      const nextForm = {
        ...current,
        [name]: type === "checkbox" ? checked : value
      };

      if (name === "closed" && checked) {
        nextForm.isActive = false;
      }

      return nextForm;
    });
  };

  const handleSubmit = async () => {
    const payload = {
      name: form.name.trim(),
      description: form.description.trim(),
      isActive: form.isActive,
      closed: form.closed
    };

    const endpoint = version ? `/api/versions/${version.id}` : "/api/versions";
    const method = version ? "PUT" : "POST";
    const res = await fetchWithAuth(endpoint, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      alert(error?.error || "Save failed");
      return;
    }

    onSaved();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{version ? "Edit version" : "Add version"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={form.description}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Check
            className="mb-2"
            type="checkbox"
            label="Closed"
            name="closed"
            checked={form.closed}
            onChange={handleChange}
          />

          <Form.Check
            type="checkbox"
            label="Active"
            name="isActive"
            checked={form.isActive}
            onChange={handleChange}
            disabled={form.closed}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VersionFormModal;
